function InProgress(){
    console.log("InProgress component is rendering");
    return(
        <div>
            I'll get to it.
        </div>
    );
}

export default InProgress;